import axios from 'axios'
import { lastValueFrom } from 'rxjs'
import { AxiosApiRequestService } from '../../features/http/api-request.service'
import { readCookie } from './read-cookie'

/**
 * Gets Facebook cookies (_fbc and _fbp) from document.cookie
 */
export const getFacebookCookies = (): { fbc: string; fbp: string } => ({
  fbc: readCookie('_fbc') ?? '',
  fbp: readCookie('_fbp') ?? ''
})

/**
 * Gets IP address from ipify.org API
 * Falls back to empty string if the request fails
 */
export const getIpAddress = async (): Promise<string> => {
  try {
    const externalAxios = axios.create()
    const ipifyService = new AxiosApiRequestService('https://api.ipify.org', externalAxios)

    const data = await lastValueFrom(
      ipifyService
        .builder<{ ip: string }>('')
        .setQueryParameters({ format: 'json' })
        .get()
    )

    return data?.ip ?? ''
  } catch (error) {
    console.error('Failed to fetch IP address:', error)
    return ''
  }
}
